export const EMPLOYEE_MODEL_ID = '41b9c5a6-310b-481e-a471-63b8a59bddff';
